import { useContext } from "react";

import { Box, IconButton, Tooltip, Container } from "src/mui";
import { useTheme, lighten, alpha, styled } from "@mui/material";
import { SidebarContext } from "src/contexts/SidebarContext";

import Logo from "src/components/LogoDark";
import HeaderMenu from "./Menu";
import SocialMedia from "./SocialMedia";

const Header = () => {
  const isMobile = document?.body?.clientWidth < 991;

  const HeaderWrapper = styled(Box)(
    ({ theme }) => `
          color: ${theme?.user?.header.textColor};
          right: 0;
          z-index: 6;
          // backdrop-filter: blur(3px);
          position: relative;
          justify-content: space-between;
          width: 100%;
  `
  );
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();
  return (
    <HeaderWrapper
      alignItems="center"
      position={{ md: "fixed", xs: "fixed" }}
      sx={{
        height: { md: theme?.user?.header?.height },
        top: 0,
        boxShadow:
          theme.palette.mode === "dark"
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.secondary[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.secondary[100],
                0.1
              )}`,
      }}
    >
      <Box
        sx={{
          backgroundColor: {
            md: theme?.colors?.alpha?.white[100],
            position: "relative",
          },
          width: "100%",
          position: "relative",
        }}
      >
        {/* Render prioritized background image for mobile to improve LCP */}
        {isMobile && (
          <Box
            component="img"
            src="/assets/img/search-header-bg-3.webp"
            loading="eager"
            fetchPriority="high"
            alt="header background"
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
            }}
          />
        )}
        <Container
          maxWidth={"lg"}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            zIndex: 2,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            sx={{ width: { md: "15%", xs: "25%" } }}
          >
            <Logo width={"100%"} />
          </Box>
          <HeaderMenu color={theme?.colors?.secondary?.main} />
          <Box sx={{ display: { md: "block", xs: "none" } }}>
            <SocialMedia />
          </Box>
          <Box sx={{ display: { md: "none" } }}>
            <Tooltip arrow title="Toggle Menu">
              <IconButton color="primary" onClick={toggleSidebar}>
                <Box
                  sx={{ width: 25 }}
                  component="img"
                  src="/assets/icons/menu.svg"
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Container>
      </Box>
    </HeaderWrapper>
  );
};

export default Header;
